import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    width: 4px;\n    height: 4px;\n    border-radius: 50%;\n    background: ", ";\n    margin: 0 5px;\n    span {\n      display: none;\n    }\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    font-size: 13px;\n    line-height: 270%;\n    margin: 0 auto 0 0;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      display: none;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 18px;\n  line-height: 18px;\n  height: 36px;\n  margin: 10px auto 10px 0;\n  position: relative;\n  transition: color 0.4s;\n  color: ", ";\n  &:before {\n    content: \"\";\n    display: block;\n    height: 2px;\n    width: ", ";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    background-color: #c34c3e;\n    transition: width 0.4s;\n    ", ";\n  }\n  &:hover {\n    cursor: pointer;\n    &:before {\n      width: 100%;\n    }\n    color: ", ";\n  }\n  ", "\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    flex-direction: row;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
import { baseFontColor, graySemi } from "@temp/@next/globalStyles/constants";
export var Wrapper = styled.div(_templateObject(), media.mediumScreen(_templateObject2()));
export var Button = styled.button(_templateObject3(), function (props) {
  return props.active ? baseFontColor : graySemi;
}, function (props) {
  return props.active ? "100%" : 0;
}, media.mediumScreen(_templateObject4()), baseFontColor, media.xxLargeScreen(_templateObject5()), media.mediumScreen(_templateObject6(), function (props) {
  return props.active ? "#2C2C2C" : "#C4C4C4";
}));